export default __webpack_public_path__ + "static/media/43.9e4e082e.gif";